import { useMultiSelectionContext } from 'src/contexts/MultiSelectionContext';
import { Checkbox } from 'src/core/interim/Checkbox';

export const EventCheckbox = ({
  eventId,
  disabled,
}: {
  eventId: string;
  disabled?: boolean;
}) => {
  const { toggleGroup, getGroupToggleState } = useMultiSelectionContext();
  const groupState = getGroupToggleState(eventId);

  const isChecked = getGroupToggleState(eventId).isGroupSelected;
  const hasPartialSelection =
    !groupState.isGroupSelected && groupState.items.length > 0;

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Checkbox
        indeterminate={hasPartialSelection}
        checked={!hasPartialSelection && isChecked}
        disabled={disabled}
        onChange={(e) => {
          toggleGroup(eventId);
        }}
      />
    </div>
  );
};
